import { Component } from "@angular/core";

/**
 * Onglet Suivi Relevés
 *
 * @author Yannick Gauthier
 * @date 01/04/2025
 */
@Component({
    host: {'data-test-id': 'suivi-releves'},
    templateUrl: './suivi-releves.component.html'
})
export class SuiviRelevesComponent {}
